export interface IIndexable<T>
{
	[ key: string ]: T;
}

export function substitute(
	a_template: string,
	a_params: IIndexable<string> = {} ): string
{
	let rv = a_template;
	for ( let k of Object.keys( a_params ) ) {
		if ( !a_params.hasOwnProperty( k ) ) {
		continue;
		}
		let re = new RegExp( "\\$\\{" + k + "\\}", "g" );
		rv = rv.replace( re, a_params[ k ] );
	}
	return rv;
}

export function hasKeyOfType( a_obj: any, a_key: string, a_type: string ): boolean
{
	return a_key in a_obj && a_type == typeof a_obj[ a_key ];
}

export function hasStringKey( a_obj: any, a_key: string ): boolean
{
	return hasKeyOfType( a_obj, a_key, "string" );
}

export function getValue<T>( a_obj: any, a_key: string, a_default: T ): T
{
	return hasKeyOfType( a_obj, a_key, typeof a_default ) ? a_obj[ a_key ] as T : a_default;
}

export function deepCopy( a_src: any, a_addId: boolean = false ): any
{
	let clone = JSON.parse( JSON.stringify( a_src ) );
	if ( a_addId && !( "id" in clone ) ) {
		clone.id = "";
	}
	return clone;
}

export function override( a_obj1: any, a_obj2: any ): any
{
	let rv: any = deepCopy( a_obj1 );
	for ( let k of Object.keys( a_obj2 ) ) {
		if ( a_obj2.hasOwnProperty( k ) && !( rv.hasOwnProperty( k ) ) ) {
			rv[ k ] = a_obj2[ k ];
		}
	}
	return rv;
}

export function isStringArray( a_arr: any ): a_arr is string[]
{
	if ( a_arr !== null && a_arr !== undefined && a_arr instanceof Array ) {
		var somethingIsNotString = false;
		a_arr.forEach( function ( item )
		{
			if ( typeof item !== 'string' ) {
				somethingIsNotString = true;
			}
		} )
		if ( !somethingIsNotString && a_arr.length > 0 ) {
			return true;
		}
	}
	return false;
}

export function createNewToken(): string
{
        let rnd = '000000' + ( Math.floor( ( Math.random() * 1000000 ) ).toFixed( 0 ) );
        return Date.now().toString() + rnd.substr( rnd.length - 6, 6 ); 
}

export class Domains
{
	static get protocol(): string
	{
		return window.location.href.split(':')[0];
	}

	static get baseDomain(): string
	{
		return window.location.hostname.replace(/[-a-zA-Z0-9]+\./, '');
	}
	
	static get gamesDomain(): string
	{
		return `games.${Domains.baseDomain}`;
	}

	static get gamesURL(): string
	{
		return `${Domains.protocol}://${Domains.gamesDomain}`;
	}

	static get apiDomain(): string
	{
		return `api.${Domains.baseDomain}`;
	}

	static get apiURL(): string
	{
		return `${Domains.protocol}://${Domains.apiDomain}`;
	}

	static get apiAudience(): string
	{
		/*
		 * NOTE:
		 * we use a fixed auth0 api with a fixed audience for all deployments
		 */
		return "https://api.fipok.com";
	}
	
	static get surveysDomain(): string
	{
		/*
		 * NOTE:
		 * if we ever wish to host the surveys separately from the games,
		 * this is the one place the domain prefix should be changed
		 */
		return `games.${Domains.baseDomain}`;
	}

	static get surveysURL(): string
	{
		return `${Domains.protocol}://${Domains.surveysDomain}`;
	}


	static get redirectDomain()
	{
		if (window.location.hostname === 'localhost') {
			return 'localhost:3000';
		}
		const parts: string[] = window.location.hostname.split('.');
		if (parts.length > 4 || parts.length < 1 || (parts[0] !== "app" && parts[0] !== "kidz" && parts[0] !== "silver")) {
			return "app.fipok.com"; 
		}
		const admissibleBaseDomains: string[] = [
			"fipok.com",
			"dev.fipok.com",
			"dev-dt.fipok.com",
			"dev-kz.fipok.com",
			"dev-ll.fipok.com",
			"dev-pb.fipok.com",
			"test.fipok.com",
		];
		if (!admissibleBaseDomains.includes(Domains.baseDomain)) {
			return "app.fipok.com";
		}
		return window.location.hostname;
	}

	static get redirectURL(): string
	{
		return `${Domains.protocol}://${Domains.redirectDomain}`;
	}
}